var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1H7.5C6.65625 1 6 1.6875 6 2.5V17L12 13.5L18 17V2.5C18 1.6875 17.3125 1 16.5 1ZM17 15.2812L12 12.3438L7 15.2812V2.5C7 2.25 7.21875 2 7.5 2H16.5C16.75 2 17 2.25 17 2.5V15.2812Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFields);
export default __webpack_public_path__ + "static/media/custom-fields.9f01bef6.svg";
export { ForwardRef as ReactComponent };